import React from "react";

//-------------------| Mensajes de validaciones |-------------------

export const Mensaje=(
    <p style={{color:"#f38c8d"}}>Campo no valido</p>
);

export const MensajeHora=(
    <p style={{color:"#f38c8d"}}>La hora de fin tiene que ser mayor que la hora de inicio</p>
);

export const MensajeFiltro=(
    <div className="uppercase text-center font-bold text-white" style={{background:"#f38c8d"}}>
        Todos los campos son obligatorios
    </div>
)

export const MensajeAdvertencia = ({ children }) => {
    return (
        <div className="uppercase text-center font-bold text-white" style={{background:"#f38c8d"}}>
            {children}
        </div>
    )
}

export const TextoAdvertencia = ({children}) => {
    return (
        <p style={{color:"#f38c8d"}}>
            {children}
        </p>
    )
}